<template>

  <v-card class="elevation-1 pa-5">

    <v-card-text class="text-center black--text">
      <img width="100" src="@/assets/logo.svg" />
      <div class="title">Squiddy</div>
      <div class="overline">Ads Monitoring Made Easy</div>
    </v-card-text>

    <v-card-text>
      <v-form id="login-form" @submit.prevent="login">
        <v-text-field prepend-icon="mdi-account" v-model="email" name="login" label="Email" type="text"></v-text-field>
        <v-text-field id="password" v-model="password" prepend-icon="mdi-lock" name="password" label="Password" type="password"></v-text-field>
      </v-form>

      <div class="login-error" v-if="hasError">
        {{ errorMessage }}
      </div>

    </v-card-text>
    <v-card-actions>
      <v-btn :to="{ name: 'forgot-password' }" text>Forgot your password?</v-btn>
      <v-spacer></v-spacer>
      <v-btn form="login-form" text :disabled="loading" :loading="loading" type="submit" color="primary">Login</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>

export default {
  data() {
    return {
      email : "",
      password : "",
      loading: false
    }
  },

  computed: {

    hasError () {
      return this.$store.state.auth.status === 'error'
    },

    errorMessage () {
      return this.$store.state.auth.errorMessage
    },

    authStatus () {
      return this.$store.state.auth.status
    }

  },

  watch: {

    authStatus (val) {
      if (val == 'error') {
        this.loading = false
      } else if (val == 'successful') {
        location.reload()
      }
    }

  },

  methods: {
    login () {
      this.loading = true
      const username = this.email
      const password = this.password
      this.$store.dispatch('LOGIN', { username, password })
    }
  }
}

</script>

<style scoped>
  .login-error {
    text-align: center;
    color: #e40000;
  }
</style>
